import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const policyActivityReducer = (
  state = initialState.policyActivityData,
  action
) => {
  switch (action.type) {
    case types.FETCH_POLICY_ACTIVITY_STARTED:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case types.FETCH_POLICY_ACTIVITY_SUCCEEDED:
      return {
        ...state,
        activityData: action.payload,
        isLoading: false
      };
    case types.FETCH_POLICY_ACTIVITY_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default policyActivityReducer;
